export default `
scalar DateTime
scalar Email

interface Node {
  id: ID!
}

interface Payload {
  clientMutationId: String!
}

enum Role {
  admin
  property_manager
  regional_manager
  org_manager
}

interface PicklistInterface {
  id: ID!
  name: String!
  region: String
  marketerEmails: String
  approvalRequired: Boolean
}

type Region implements Node {
  id: ID!
  name: String!
}

type Org implements PicklistInterface & Node {
  createdAt: DateTime!
  id: ID!
  name: String!
  marketerEmails: String
  approvalRequired: Boolean
  suborgs(name: String=""): [Suborg!]!
  regions: [Region]!
  role: [Role]!
  region: String
  accounts(
    after: String,
    before: String,
    first: Int=15,
    last: Int=15,
  ): AccountsConnection!
}

type Suborg implements PicklistInterface & Node {
  createdAt: DateTime!
  id: ID!
  name: String!
  org: Org!
  region: String
  marketerEmails: String
  approvalRequired: Boolean
}

type AccountsListNode implements PicklistInterface & Node {
  id: ID!
  name: String!
  region: String
  marketerEmails: String
  approvalRequired: Boolean
}

type Notification implements Node {
     id: ID!
     created_at: String
     header: String
     body: String
     status: String
}

type Template implements Node {
  createdAt: DateTime!
  id: ID!
  largeThumbnailUrl: String
  name: String!
  smallThumbnailUrl: String
}

type Category implements Node {
  assets(name: String): [Asset!]!
  createdAt: DateTime!
  hasMore: Boolean!
  id: ID!
  name: String!
  templates(name: String): [Template!]!
  type: String!
}

enum access_type {
  none
  vendor
  user
  admin
}

enum appsAuthorizationType {
  app
  hub
}

type AppModule {
  name: String
  access_type: access_type
}


type AuthorizedApp {
  name: String
  access: access_type
  url: String
  type: appsAuthorizationType
  appModules: [AppModule!]!
}

type User implements Node{
     id: ID!
     name: String
     property: String
     org: Org!
     notifications: [Notification]
}


type Account implements Node {
  id: ID!
  email: Email
  first_name: String
  last_name: String
  lastLogin: DateTime
  initials: String
  signature: String
  org: Org
  role: Role
  authorizedSuborgs: [Suborg!]!
  authorizedRegions: [Region!]!
  authorizedApps: [AuthorizedApp!]!
}


type AccountNode {
    node: Account!
    cursor: String!
}

type AccountsConnection {
  id: ID!
  edges: [AccountNode!]!
  pageInfo: PageInfo!
  totalCount: Int
}

input NotificationDeleteInput {
  id: ID!
  user_id: String
  clientMutationId: String!
}

type PageInfo {
  endCursor: String
  hasNextPage: Boolean!
  hasPreviousPage: Boolean!
  startCursor: String
}

type AssetConnection {
  edges: [AssetEdge]
  nodes: [Asset]
  pageInfo: PageInfo!
}

type AssetEdge {
  cursor: String!
  node: Asset
}

type Asset implements Node {
  createdAt: DateTime!
  fileSize: String!
  fileType: String!
  fileUrl: String!
  id: ID!
  name: String!
  thumbnailUrl: String
}

input uploadAssetInput {
  clientMutationId: String
  propertyId: ID!
  categoryId: ID!
  name: String!
  imageData: String!
}

type uploadAssetPayload {
  asset: Asset
  assetEdge: AssetEdge
  assetsConnection: AssetConnection
  clientMutationId: String
}

type Query {
  account(id: ID!): Account
  org(id: ID!): Org!
  accounts(orgId: ID!, after: String, before: String, first: Int=15, last: Int=15,): AccountsConnection!
  accountsList(name: String, first: Int=15): [AccountsListNode!]!
  # the id here will be 'suborgs-org.id' to work in the refetch container
  authorizedOrgs(name: String, first: Int=50): [Org!]!
  authorizedSuborgs(orgId: ID!, name: String): [Suborg!]!
  notifications(id: ID!): [Notification!]!
  categories(
    propertyId: ID!
    type: String = "template"
  ): [Category!]!
}

type Mutation {
  notificationDelete(input: NotificationDeleteInput!): Payload
  uploadAsset(input: uploadAssetInput!): uploadAssetPayload
}

schema {
  query: Query
  mutation: Mutation
}
`
